import { AppSwitcher as AppSwitcherWSC } from '@trackman/web-shared-components';
import { useStores } from 'index';
import { observer } from 'mobx-react-lite';
import React from 'react';
import { AppSwitcherWrapper } from './AppSwitcherStyles';

type Props = {
  setDisplayContent: React.Dispatch<React.SetStateAction<boolean>>;
};

const AppSwitcher = observer(({ setDisplayContent }: Props) => {
  const ss = useStores().startupStore;

  const apps = ss.apps.map((app) => ({
    id: app.id,
    appLabel: app.display_name,
    groupLabel: app.group,
    iconName: app.icon_name,
    url: app.base_url,
  }));

  return (
    <AppSwitcherWrapper>
      <AppSwitcherWSC
        label='Live Dashboard'
        apps={apps}
        onAppClick={(appUrl) => {
          setDisplayContent(false);
          window.location.href = appUrl;
        }}
        activeAppId={'softball-livedashboard'} // Replace with your app's id
      />
    </AppSwitcherWrapper>
  );
});

export default AppSwitcher;
